export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Coluna Suporte",
              attributes: { class: 'column column-50 p-20 justify-content-center' },
              components: [
                {
                  tagName: 'h2',
                  type:'text',
                  name:'Titulo',
                  components: 'Central de suporte',
                  attributes: {class: 'principal-title'}, 
                  traits: [
                    {
                      type: "select",
                      options: [
                        { value: "h1", name: opts.labelN1 },
                        { value: "h2", name: opts.labelN2 },
                        { value: "h3", name: opts.labelN3 },
                        { value: "h4", name: opts.labelN4 },
                        { value: "h5", name: opts.labelN5 },
                        { value: "h6", name: opts.labelN6 },
                      ],
                      label: 'Tamanho',
                      name: "tagName",
                      changeProp: 1,
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'Id', 
                    },
                  ],
                },
                {
                  type:'text', 
                  name:'Subtitulo',
                  content: 'Subtítulo', 
                  attributes: {class:'subtitle text-uppercase margin-top-15'},
                }, 
                {
                  type: 'text',
                  content:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et bibendum risus. Cra', 
                  attributes: {class: 'body-text'},
                },
                {
                  type: 'button',
                },
              ],
              styles: `
               .principal-title{
                font-size: 30px; 
                color: #363940;
                margin:0;
               }
               .body-text{
                font-size: 16px; 
                color: #363940; 
                margin-top:30px;
               }
               .subtitle{
                font-size: 13px; 
                color: #747474; 
               }
               .text-uppercase{
                text-transform: uppercase;
               }
               .margin-top-15{
                margin-top:15px; 
               }
               .column{
                display:flex; 
                flex-direction:column; 
                align-items: flex-start;
               }
               .column-50{
                width:50%; 
               }
               .p-20{
                padding:20px;
               }
               .justify-content-center{
                justify-content:center;
               }
               @media (max-width:992px){
                .column{
                  align-items: center;
                 }
                 .colum-50{
                  width:100%; 
                 }
               }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};